import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    inject,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { IListingSortOption } from '@df/catalog-ui/listing/sort/listing-sort';
import { ListingSortComponentDef } from '@df/catalog-ui/listing/sort/listing-sort.component.def';
import { GtmService } from '@df/module-gtm/gtm.service';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { ModalService } from '@df/ui/modal/modal.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
    selector: 'listing-sort',
    templateUrl: './listing-sort.html',
    styleUrl: './listing-sort.scss',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListingSortComponent extends ListingSortComponentDef implements OnInit, OnDestroy {
    @Output()
    filtersClose = new EventEmitter();

    @Output()
    filtersOpen = new EventEmitter();

    @ViewChild('modalContent')
    modalContent!: TemplateRef<unknown>;

    protected subscriptions: Subscription = new Subscription();

    protected modalService = inject(ModalService);
    protected changeDetectorRef = inject(ChangeDetectorRef);
    protected gtmService = inject(GtmService);

    private _modalRef?: ModalRef<unknown>;

    get selectedLabel() {
        return this.sort.selectionLabel;
    }

    ngOnInit() {
        this.subscriptions.add(this.sort.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    openModal(visuallyHidden = false) {
        if (this.modalContent) {
            this._modalRef = this.modalService.open(
                this.modalContent,
                {
                    minWidth: undefined,
                    maxWidth: undefined,
                    width: '480px',
                    position: {
                        top: '0',
                        right: '0',
                        bottom: '0'
                    },
                    modalClass: 'listing-sort-modal p-a-0',
                    panelClass: visuallyHidden ? 'visually-hidden' : '',
                    hasBackdrop: !visuallyHidden,
                    scrollStrategy: visuallyHidden || (this.app.client.isS && !this.app.client.isCms && !visuallyHidden) ? 'noop' : 'block',
                    onClose: () => {
                        this.filtersClose.emit();
                    },
                    onOpen: () => {
                        this.filtersOpen.emit();
                    }
                },
                'right'
            );

            this.sendGtmEvent('openSortBy');

            this.filtersOpen.emit();
        }
    }

    handleSortBy(option: IListingSortOption | undefined) {
        this.closeModal();

        this.sort.by(option);
        this.detectChanges();
    }

    closeModal() {
        this._modalRef?.close();
        this.sendGtmEvent('closeSortBy');
    }

    private sendGtmEvent(event: string): void {
        this.gtmService.push({ event });
    }
}
